import { useSelector } from 'react-redux';
import moment from 'moment';
import { getLatestAcceptedInvoice } from '../constants/utils';

const useClientPortalCorrectInterestRate = () => {
  const creditInformation = useSelector(
    (state) => state.memberPortal?.clientDataInformation
  );
  const creditInformationPartialRedemption = useSelector(
    (state) => state.lead?.clientDataForPartialRedemption
  );
  const creditFacilityData =
    creditInformation?.creditFacilityData ||
    creditInformationPartialRedemption?.creditFacilityData;
  const {
    status: creditStatus,
    expirationDate,
    interestRate,
  } = creditFacilityData || {};

  const installmentLoans = creditFacilityData?.installmentLoanDataList;
  const latestAcceptedLoan = getLatestAcceptedInvoice(installmentLoans);

  let isCreditExpired = false;
  const momentExpirationDate = moment(expirationDate, 'YYYY-MM-DD');
  const today = moment().startOf('day');

  if (momentExpirationDate.isSameOrBefore(today)) {
    isCreditExpired = true;
  }

  const finalInterestRate =
    creditStatus === 'ACTIVE' && isCreditExpired
      ? interestRate
      : latestAcceptedLoan?.interestRate;

  return finalInterestRate ?? interestRate;
};

export default useClientPortalCorrectInterestRate;
